export enum TabValues {
  ALL_JETS = 'All Jets',
  LIGHT_JET = 'Light Jet',
  MID_SIZE_JET = 'Mid-Size Jet',
  SUPER_MID_SIZE_JET = 'Super Mid-Size Jet',
  HEAVY_JET = 'Heavy Jet',
}

export interface JetCatalogItem {
  id: number;
  category: string;
  name: string;
  image: string;
  tail: string;
  passengers: string;
  price: string;
  pdf: string;
  mostPopular?: boolean;
}

export interface JetCatalogData {
  jetCatalogData: JetCatalogItem[];
}
